/**
 * Error wrapper for use with fetch.
 */
class FetchError extends Error {
}

export default FetchError;
